import { useEffect } from "react";

import { injectScript, runOnFirstInteraction } from "@/utils/thirdPartyScripts";

const CARROT_QUEST_CDN_URL = "https://cdn.carrotquest.app/api.min.js";
const CARROT_QUEST_API_KEY = "53085-2c065d496d742578110c022882";
const GET_REVIEW_URL = "https://app.getreview.io/tags/ceaHMxfoQ0wYd9YD/sdk.js";

/** Методы, которые снипет CarrotQuest подменяет заглушками до загрузки основного скрипта. */
const CARROT_QUEST_METHODS = [
  "connect", "track", "identify", "auth", "onReady",
  "addCallback", "removeCallback", "trackMessageInteraction",
];

type CarrotQuestWindow = Window & {
  carrotquestasync?: unknown[];
};

/**
 * Инициализация CarrotQuest — тот же снипет, что раньше стоял инлайном в `<Helmet>`,
 * только выполняется по первому действию пользователя, а не при загрузке страницы.
 * Заводит очередь команд и подключает основной скрипт чата.
 */
const initCarrotQuest = () => {
  const w = window as CarrotQuestWindow;

  if (typeof w.carrotquest === "undefined") {
    const queue: unknown[] = [];
    const stub: Record<string, unknown> = { settings: {} };

    CARROT_QUEST_METHODS.forEach((method) => {
      stub[method] = (...args: unknown[]) => {
        queue.push(method, args);
      };
    });

    w.carrotquestasync = queue;
    // Единственное приведение на границе с внешним скриптом: заглушка повторяет форму,
    // которую потом заменит настоящий api.min.js (см. глобальный тип в global.d.ts).
    w.carrotquest = stub as unknown as Window["carrotquest"];
  }

  // Загрузчик создаёт скрытый iframe и тянет в него код чата с cdn.carrotquest.app.
  // Зеркало на cdn.carrotquest.io отдаёт тот же файл и ведёт туда же — второй тег не нужен.
  injectScript(CARROT_QUEST_CDN_URL);

  (w.carrotquest as unknown as { connect?: (key: string) => void }).connect?.(CARROT_QUEST_API_KEY);
};

/**
 * Сторонние скрипты, которые не нужны до первого действия пользователя (SEO #12, task 4575).
 *
 * CarrotQuest (чат) — по согласованию с продуктом подключается только после клика, скролла
 * или движения мыши: до этого его на странице нет вовсе.
 *
 * GetReview (видео-виджеты) грузится по тому же триггеру на всех страницах. В коде виджеты
 * стоят только на главной, но тексты страниц приходят из Strapi готовым HTML и могут содержать
 * вставку виджета, которой в коде не видно, — поэтому скрипт не привязан к шаблону.
 */
const OtherScriptsHelmet = () => {
  useEffect(() => {
    runOnFirstInteraction(() => {
      initCarrotQuest();
      injectScript(GET_REVIEW_URL);
    });
  }, []);

  return null;
};

export default OtherScriptsHelmet;
